export default "__VITE_ASSET__HZaDThwj__"